module.exports = __webpack_public_path__ + "static/img/icon.4c6c237d.png";